import { makeStyles } from '@material-ui/core/styles';
import { NotificationType } from '@src/shared/context/notifications';

const useStyles = makeStyles(
  ({ typography, palette, variables, breakpoints }) => ({
    actionButtons:{
      display: 'flex',
      justifyContent: 'end',
      marginBottom:variables?.spacingD,
     '& .jetButton:has(+.jetButton)':{
        marginRight:variables?.spacingD
      }
    },
    notificationInnerWrapper:{
      display:'flex',
      paddingTop: variables?.spacingD,
      paddingBottom: variables?.spacingD,
      justifyContent:'space-evenly',
      '&.no-title': {
        justifyContent:'unset',
        alignItems:'center'
      }
    },
    notification: {
      height:'auto',
      position:'relative',
      display: 'flex',
      borderRadius:variables?.radiusRoundedC,
      transition: 'opacity 0.2s',
      width:'347px',
      wordBreak:'break-word',
      paddingLeft:variables?.spacingD,
      paddingRight:variables?.spacingD,
      flexDirection:'column',
      [`&.type-${NotificationType.Success}`]: {
        backgroundColor: palette.jet?.supportPositive02,
      },
      [`&.type-${NotificationType.Error}`]: {
        backgroundColor: palette.jet?.supportError02,
      },
      [`&.type-${NotificationType.Information}`]: {
        backgroundColor: palette.jet?.supportInfo02,
      },
      [`&.type-${NotificationType.Warning}`]: {
        backgroundColor: palette.jet?.supportWarning02,
      },
      '&.animated-enter, &.animated-exit-active': {
        opacity: 0,
      },
      '&.animated-enter-active, &.animated-exit': {
        opacity: 1,
      },
      [breakpoints.down('sm')]: {
        width:'100%'
      },
      [breakpoints.down('xs')]: {
        width:'90vw'
      },
      '&.fullsize': {
        width:'100%',
        height:'100%'
      }
    },
    notificationIcon: {
      marginRight: variables?.spacingB,
      alignSelf:'baseline'
    },
    closeIcon:{
      cursor:'pointer',
      marginLeft:'auto',
      height:'12px',
      [breakpoints.down('md')]: {
        marginLeft:'auto',
        marginRight:variables?.spacingNone
      }
    },
    notificationMessageWrapper:{
      display: 'flex',
      flexWrap: 'wrap',
      alignContent: 'center'
    },
    notificationContent: {
      display: 'flex',
      whiteSpace: 'break-spaces'

    },
    notificationHeader: {
      width:'100%',
      alignItems: 'baseline',
      display:'flex'
    },
    notificationTitle: {
      flex:1
    }
  })
);

export default useStyles;
